<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24"> </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="wechatAppId" slot-scope="text, record">
          <span
            v-for="item in wechatList"
            :key="item.id"
            v-show="item.appId == text"
            >{{ item.name }}</span
          >
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status === 1 ? true : false"
            checked-children="启用"
            un-checked-children="未启用"
            @click="handleChange(record)"
          />
        </template>
        <template slot="audit" slot-scope="text, record">
          <a-switch
            :checked="record.sendAudit === 1 ? true : false"
            checked-children="是"
            un-checked-children="否"
            @click="handleAuditChange(record)"
          />
        </template>
        <template slot="templateContent" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <pre>{{ text }}</pre>
            </template>
            <a>查看</a>
          </a-tooltip>
        </template>
        <template slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="pushList(record)">记录</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => handleDelete(record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>

    <notice-modal ref="modalForm" @ok="modalFormOk"></notice-modal>
    <a-modal
      title="推送记录"
      :visible="visible"
      @cancel="visible = false"
      :width="900"
    >
      <div style="margin-bottom: 16px">
        <a-button
          type="primary"
          :disabled="selectedRowKeys.length == 0"
          @click="btnBatchSend"
          >批量推送</a-button
        >&nbsp;&nbsp;
        <a-date-picker
          v-model="noticeListDate"
          format="YYYY-MM-DD"
        />&nbsp;&nbsp;
        <a-button type="primary" @click="pushList">查询</a-button>
      </div>
      <a-table
        :row-selection="{ onChange: onSelectChange }"
        rowKey="id"
        :columns="listColumns"
        :data-source="tradeNoticeList"
        :pagination="false"
      >
        <template slot="status" slot-scope="text, record">
          <span v-if="text == 1">待审核</span>
          <span v-if="text == 2">推送中</span>
          <span v-if="text == 3">已推送</span>
          <span v-if="text == 4">推送失败</span>
        </template>
        <template slot="templateContent" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <pre>{{ text }}</pre>
            </template>
            <a>查看</a>
          </a-tooltip>
        </template>
        <template slot="createTime" slot-scope="text, record">
          {{ moment(text).format('HH:mm') }}
        </template>
        <template slot="cause" slot-scope="text, record">
          <span v-if="text && text.length < 10">{{ text }}</span>
          <a-tooltip v-else-if="text && text.length > 5" placement="top">
            <template slot="title">
              <pre>{{ text }}</pre>
            </template>
            {{ text.substring(0, 5) }}&nbsp;<a>详细</a>
          </a-tooltip>
          <span v-else>&nbsp;</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a
            @click="sendNotice(record)"
            v-if="record.status == 1 || record.status == 4"
            >推送</a
          >&nbsp;
          <a-popconfirm
            title="确定删除此条推送吗?"
            @confirm="() => handleListDelete(record.tradeNoticeId, record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment';
import 'moment/locale/zh-cn';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import NoticeModal from './modules/NoticeModal';
import { getAction, postAction } from '@api/manage';

export default {
  name: 'UserTradeNotice',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    NoticeModal
  },
  data() {
    return {
      moment,
      visible: false,
      description: 'UserTradeNotice管理页面',
      // 表头
      columns: [
        {
          title: '唯一代码',
          align: 'center',
          dataIndex: 'code'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text;
          }
        },
        {
          title: '模板名称',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '公众号AppId',
          align: 'center',
          dataIndex: 'wechatAppId',
          scopedSlots: { customRender: 'wechatAppId' }
        },
        {
          title: '微信模板ID',
          align: 'center',
          dataIndex: 'wechatTemplate'
        },
        {
          title: '模板内容',
          align: 'center',
          dataIndex: 'templateContent',
          scopedSlots: { customRender: 'templateContent' }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '审核',
          align: 'center',
          dataIndex: 'audit',
          scopedSlots: { customRender: 'audit' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      listColumns: [
        {
          title: '交易账号',
          align: 'center',
          dataIndex: 'taAcco'
        },
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'clientName'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '内容',
          align: 'center',
          dataIndex: 'templateContent',
          scopedSlots: { customRender: 'templateContent' }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '推送失败原因',
          align: 'center',
          dataIndex: 'cause',
          scopedSlots: { customRender: 'cause' }
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      selectedRowKeys: [],
      url: {
        wechatAppList:
          process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType',
        list: process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/list',
        tradeNoticeList:
          process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/list/list',
        sendNotice:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/user/trade/notice/list/batchSend',
        delete:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/user/trade/notice/list/deleteBatch',
        deleteBatch:
          process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/importExcel',
        updateStatus:
          process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/updateStatus',
        updateAudit:
          process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/updateAudit'
      },
      currentTradeNoticeId: '',
      noticeListDate: moment(new Date()),
      wechatList: [],
      dictOptions: {},
      tradeNoticeList: []
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    initDictConfig() {
      getAction(this.url.wechatAppList, { type: '1,2' }).then(res => {
        if (res.success && res.result) {
          this.wechatList = res.result;
        }
      });
    },
    handleChange(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要停用所选数据?';
      let that = this;
      let type = record.status == '1' ? '0' : '1';
      this.$confirm({
        title: record.status == '1' ? '停用' : '启用',
        content: record.status == '1' ? strClose : strOpen,
        onOk() {
          postAction(that.url.updateStatus, {
            id: record.id,
            status: type
          }).then(res => {
            if (res.success) {
              //刷新页面
              that.loadData();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    handleAuditChange(record) {
      let strOpen = '确定要审核所选数据?';
      let strClose = '确定不需要审核所选数据?';
      let that = this;
      let type = record.sendAudit == '1' ? '0' : '1';
      this.$confirm({
        title: '推送通知是否需要审核？',
        content: record.sendAudit == '1' ? strClose : strOpen,
        onOk() {
          postAction(that.url.updateAudit, { id: record.id, audit: type }).then(
            res => {
              if (res.success) {
                //刷新页面
                that.loadData();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            }
          );
        }
      });
    },
    pushList(record) {
      this.tradeNoticeList = [];
      if (record && record.id) {
        this.currentTradeNoticeId = record.id;
      } else {
        record = { id: this.currentTradeNoticeId };
      }
      let date = this.noticeListDate;
      date = date.format('YYYY-MM-DD');
      getAction(this.url.tradeNoticeList, {
        tradeNoticeId: record.id,
        date: date
      }).then(res => {
        if (res.success && res.result) {
          this.tradeNoticeList = res.result;
        }
      });
      this.visible = true;
    },
    sendNotice(record) {
      this.batchSendNotice([record.id].toString(), function() {
        record.status = 2;
      });
    },
    btnBatchSend() {
      let that = this;
      this.batchSendNotice(this.selectedRowKeys.toString(), function() {
        that.visible = false;
      });
    },
    batchSendNotice(ids, callback) {
      postAction(this.url.sendNotice, { ids: ids }).then(res => {
        if (res.success) {
          this.$message.success('提交完成，开始推送中...');
          if (callback) {
            callback();
          }
        }
      });
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys;
    },
    handleListDelete(tradeNoticeId, id) {
      postAction(this.url.delete, { ids: id }).then(res => {
        if (res.success) {
          this.$message.success('删除成功');
          this.pushList({ id: tradeNoticeId });
        }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
